import { LockStoreDAO } from "./types"

export { LockStore } from "./lock-store"
export { LockRepository } from "./lock-repository"
export { LockApiTransport } from "./lock-api-transport"
export { LockOnChainTransport } from "./lock-on-chain-transport"
export type { ILockRepository, ILockApiTransport, ILockRefreshStrategy } from "./interfaces"
export { LockOrchestrator } from "./lock-orchestrator"
export { LockOrchestratorFactory } from "./lock-orchestrator-factory"
export { LockStoreFactory } from "./lock-store-factory"
export { convertApiResponseToLockStoreDAO } from "./lock-converter"
export type { ILock, LockApiData, LockStoreDAO } from "./types"
export type { LockOnChainTransportAddresses } from "./lock-on-chain-transport"
export { WalletAddressSource } from "./wallet-address-source"

export const makeDefaultLockStoreDAO = (): LockStoreDAO => {
  return {
    id: 0,
    canWithdraw: false,
    hasExpired: false,
    hasVotedThisEpoch: false,
    hasVotes: false,
    isMaxLocked: false,
    isReset: false,
    lastVoted: 0,
    lockAmount: 0,
    lockAmountRaw: 0n,
    lockEnds: 0,
    lockValue: 0,
    needsResetToWithdraw: false,
  }
}
